module.exports = __webpack_public_path__ + "img/QD.f179f612.png";